import React from 'react';
import { Spin } from 'antd';
import styles from './CountBox.module.scss';

type Props = {
  title: string;
  count: string;
  tip: string;
  icon: string;
  loading?:boolean;
}

const CountBox: React.FC<Props> = ({
  title, count, tip, icon, loading,
}) => (
  <div className={styles.wrapper}>
    <h3 className={styles.title}>{title}</h3>
    <div className={`g-font-num ${styles.count}`}>
      {
        loading
          ? <Spin />
          : count
      }
    </div>
    <div className={styles.tip}>{tip}</div>
    <i className={`iconfont ${icon} ${styles.icon}`} />
  </div>
);

export default CountBox;
